var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("       "+_vm._s(_vm.words[0]))]),_c('br'),_c('p',[_vm._v("       "+_vm._s(_vm.words[1]))]),_c('br'),_c('img',{attrs:{"alt":"#","src":require('../../../assets/img/research2.png')}})])}
var staticRenderFns = []

export { render, staticRenderFns }